module.exports = "<app-nav-bar [@navBarState]=\"navBarState()\"></app-nav-bar>\n<router-outlet></router-outlet>\n\n<app-image-gallery-view *ngIf=\"ImageGalleryService.isGalleryOpen && ImageGalleryService.gallery\" [images]=\"ImageGalleryService.gallery\" [currentIndex]=\"ImageGalleryService.galleryIndex\"></app-image-gallery-view>\n\n<app-image-gallery-view *ngIf=\"ImageGalleryService.isGalleryOpen && ImageGalleryService.selectedImage\" [image]=\"ImageGalleryService.selectedImage\"></app-image-gallery-view>"


//////////////////
// WEBPACK FOOTER
// ./src/app/view-with-nav-bar/view-with-nav-bar.component.html
// module id = ./src/app/view-with-nav-bar/view-with-nav-bar.component.html
// module chunks = main